"use client";
import React from "react";
import { RotateCw } from "lucide-react";
import {
  useSwapCalculatorComputed,
  useSwapFormState,
  useSwapLists,
} from "modules/swap-calculator/stores/useSwapCalculatorStore";
import { useConfirmResetModal } from "modules/swap-calculator/stores/useSwapCalculatorModalsStore";

function ActionBar() {
  // Optimal Zustand selectors with shallow equality
  const { leftCards, rightCards, addCardToLeft, addCardToRight } =
    useSwapLists();
  const { selectedCard, setAutocompleteKey, resetAutocomplete } =
    useSwapFormState();
  const { currentTradeCard } = useSwapCalculatorComputed();

  const { setOpen: setConfirmResetModalOpen } = useConfirmResetModal();

  const handleReset = () => {
    setConfirmResetModalOpen(true);
  };

  const handleAddSelectedCard = (side: "left" | "right") => {
    if (!currentTradeCard) return;

    if (side === "left") {
      addCardToLeft(currentTradeCard);
    } else {
      addCardToRight(currentTradeCard);
    }

    // Reset the autocomplete using the registered callback
    resetAutocomplete();
    setAutocompleteKey(currentTradeCard.id);
  };

  const isResetDisabled = rightCards.length === 0 && leftCards.length === 0;
  const isAddDisabled = !selectedCard?.id;

  return (
    <div className="w-full">
      <div className="flex w-full items-center justify-between gap-2">
        <button
          className="btn btn-sm btn-secondary md:btn-md flex-1"
          disabled={isAddDisabled}
          onClick={() => handleAddSelectedCard("left")}
        >
          Add card
        </button>

        <button
          className="btn btn-sm btn-warning md:btn-md"
          disabled={isResetDisabled}
          onClick={handleReset}
          aria-label="Reset trade"
        >
          <RotateCw className="h-6 w-6 md:h-8 md:w-8" />
        </button>

        <button
          className="btn btn-sm btn-primary md:btn-md flex-1"
          disabled={isAddDisabled}
          onClick={() => handleAddSelectedCard("right")}
        >
          Add card
        </button>
      </div>
    </div>
  );
}

export default ActionBar;
